export const roomPaths = {
  basePath: '/sala-atendimento',
  immediate: {
    fullPath: '/sala-atendimento/imediato/:roomId',
    basePath: '/sala-atendimento/imediato',
  },
  scheduled: {
    fullPath: '/sala-atendimento/agendado/:roomId/:id',
    basePath: '/sala-atendimento/agendado',
  },
}
